import React from "react";
import { Navigate } from "react-router-dom";
import { useCurrentUser } from "../slices/auth/hooks";

export const RoleBaseRoutes = ({ allowedRoles, children }) => {
  const currentUser = useCurrentUser();
  const { role } = currentUser;

  if (!allowedRoles.includes(role)) {
    return <Navigate to="/profile" />;
  }

  return <>{children}</>;
};
